exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-carousel__inner {\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n.avatar-carousel__item {\r\n  display: inline-block;\r\n}\r\n\r\ncm-avatar {\r\n  border: 4px solid #1D1D1D;  \r\n  border-radius: 50%;  \r\n}\r\n\r\n.avatar-carousel__pagination {\r\n  text-align: center;\r\n}\r\n\r\n.avatar-carousel__pagination button {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 255, 255, 0.5);  \r\n  margin: 5px;\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n\r\n.avatar-carousel__pagination button:focus {\r\n  outline: 0;\r\n}\r\n\r\n.avatar-carousel__pagination button.active {\r\n  background-color: #FFF;  \r\n}\r\n\r\n.avatar-carousel__image {\r\n  width: 8em;\r\n  height: 8em;\r\n  margin: auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/avatar-carousel/avatar-carousel.component.css
// module id = ../../../../../src/app/shared/avatar-carousel/avatar-carousel.component.css
// module chunks = 4